<template>
    <div class="container">
        <div class="card" :id="title">
            <div
            class="card-header text-center"
            data-toggle="collapse"
            :href="'#collapseCard' + count"
            role="button"
            aria-expanded="false"
            :aria-controls="'collapseCard' + count">
                {{ title }}
            </div>
            <div class="collapse show" :id="'collapseCard' + count">
                <div class="card-body">
                    <div class="d-flex flex-row">
                        <div class="col-4" v-if="textLeft">
                            <p class="textLeft">
                                {{ textLeft }}
                            </p>
                        </div>
                        <!--<div class="col">
                            <p class="">
                                {{ text }}
                            </p>
                        </div>-->
                        <div class="col">
                            <ul>
                                <li v-for="(bulletPoint, index) in bulletPoints"
                                :key=index>
                                    {{bulletPoint}}
                                </li>
                            </ul>                            
                        </div>    
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InformationLetter",
    props: ["title", "textLeft", "text", "count", "recommendationId"],
    data: function(){
        return{
            bulletPoints: []
        }
    },
    created() {
        //console.log("created InformationLetter");
        this.bulletPoints = this.text.split("<br/>");
       // console.log("bulletPoints:");
        //console.log(this.bulletPoints);
    },
    mounted(){
        //console.log("mounted InformationLetter");
    },
    updated(){
        /*console.log("updadted Informationletter:");
        console.log(this.title);*/
    },
    methods:{
        
    },
};
</script>

<style scoped>
.card-header::after{
    content:"\f0d8";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    margin-left: 0.255em;

    font-size: 15px;
    height: 26px;
    
}
.card-header.collapsed::after{
    content:"\f0d8";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    margin-left: 0.255em;

    transform: rotate(-180deg);
    font-size: 15px;
    height: 26px;
}
</style>
